// extracted by mini-css-extract-plugin
export default {"categoriesSidebar":"CategoriesSidebar_categoriesSidebar__D6Eoj","selectedCategory":"CategoriesSidebar_selectedCategory__ySfqv"};